import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { useHybridAuth } from './useHybridAuth';
import { AxiosError } from 'axios';
import { driverApi, LocationUpdate } from '../services/driverApi';

const updateLocationRequest = async (data: {
  token: string;
  location: LocationUpdate;
  companyId?: string;
}) => {
  driverApi.setAuthToken(data.token);
  return driverApi.updateLocation(data.location, data.companyId);
};

/**
 * @param companyId Company the driver is active in, from the profile. The
 * endpoint needs it; without it every update is rejected.
 */
export const useUpdateLocation = (
  companyId?: string,
  config?: Omit<
    UseMutationOptions<
      { message: string },
      AxiosError,
      LocationUpdate,
      unknown
    >,
    'mutationFn'
  >
) => {
  const { getAccessTokenSilently } = useHybridAuth();

  return useMutation({
    ...config,
    mutationFn: async (location: LocationUpdate) => {
      const token = await getAccessTokenSilently();
      return updateLocationRequest({ token, location, companyId });
    },
  });
};
